import { mergeNavNeededMaps } from '@sharedCR/common/NavNeededIndicator/NavNeededIndicator.utils';
import _ from 'lodash';

import { ENTITY_TYPE_HREF } from './EditEntityModal.hrefs';

// Kept out of EditEntityModal.constants (which transitively pulls FormEditor's ESM-only deps that
// Jest cannot transform) so the entity-scoping rule below stays directly testable.

/**
 * The completeness roll-up map a drawer entity's nav items resolve against.
 *
 * Loan-scoped items carry no owning borrower, so they belong in EVERY borrower's drawer — that is what
 * lights the outer rail. A non-borrowing entity must NOT inherit them: it shares this head/nav-tab
 * builder but has no borrower tabs to answer for a `borrowers-*` ref, so folding them in would stamp the
 * borrower's count onto an NBE head tab.
 */
export const getEntityNavMap = ({
  subtab,
  entityId,
  navNeededByBorrower = {},
  navNeededLoanScoped = {},
}) =>
  subtab === ENTITY_TYPE_HREF.BORROWER
    ? mergeNavNeededMaps(navNeededLoanScoped, navNeededByBorrower[entityId])
    : (navNeededByBorrower[entityId] ?? {});

/**
 * The bare `borrowers/nbe` route (no entity) is where "Go to field" lands a non-borrowing
 * entity field, since checklists carry no NBE id. The Borrowers page resolves it to the loan's
 * only NBE drawer, or to the entity list (LEN2-499), so the drawer must not close it first.
 *
 * @param {{ subtab: string, entityId: string }} params - the loan management route params
 * @returns {boolean}
 */
export const checkIsNbeLandingRoute = ({ subtab, entityId }) =>
  subtab === ENTITY_TYPE_HREF.NON_BORROWER && _.isNil(entityId);
